/**
 * TanStack Query hook for the authenticated /api/entities read.
 *
 * First real backend round trip from the SPA — proves MSAL token
 * acquisition, CORS, Bearer validation on the Function App, and the
 * end-to-end Entra audience match all work.
 */
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/apiClient";
import type { Entity } from "@/lib/mockData";

interface EntitiesResponse {
  items: Entity[];
}

export function useEntities() {
  return useQuery({
    queryKey: ["entities"],
    queryFn: () => apiFetch<EntitiesResponse>("/entities"),
    staleTime: 60_000,
    retry: 1,
  });
}
